export const MESSENGER_TO_REPLACE = '%Messenger%';
export const CHANNEL_TO_REPLACE = '%channel%';
